// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import MintUI from "mint-ui"; // 加这一行
import "mint-ui/lib/style.css"; // 和加这一行
import "../static/css/base.css";
import "../static/iconfont/iconfont.css";
import utils from "./utils/utils";
import axios from "axios";
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
// get_from, up_excel
import { post, get } from "./utils/axios";
import { hpost, hget } from "./utils/hxios";
import { spost, sget } from "./utils/sxios";
import { mpost, mget } from "./utils/mxios";
Vue.use(ElementUI);

Vue.prototype.$get = get;
// Vue.prototype.$get_from = get_from;
// Vue.prototype.$up_excel = up_excel;
Vue.prototype.$post = post;

Vue.prototype.$hget = hget;
Vue.prototype.$hpost = hpost;
Vue.prototype.$spost = spost;
Vue.prototype.$sget = sget;
Vue.prototype.$mget = mget;
Vue.prototype.$mpost = mpost;

Vue.config.productionTip = false;

//解决跨域
Vue.prototype.HOST = "/api";
//引入
Vue.prototype.utils = utils;
Vue.prototype.$axios = axios;

Vue.use(MintUI); // 还有加这一行
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js